module.exports = __webpack_public_path__ + "img/ByWmAZMTiZrlLRM84Z3ByD8fyfw.a80c9906.png";